"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Trust() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const credentials = ["Professional Grade", "Capital Architect", "Deal Reviewer"];
  return <section data-section-id="791" id="trust-security" className="bg-background py-20">
      <div ref={ref} className={`mx-auto max-w-6xl px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <div className="flex justify-center">
          <span className="text-xs font-default font-medium uppercase tracking-[0.2em]" style={{
          color: "var(--secondary)"
        }}>
            Why BeneWealth
          </span>
        </div>

        {}
        <p className="mt-6 mx-auto text-center font-default text-foreground/90 leading-relaxed" style={{
        maxWidth: "560px",
        fontSize: "18px"
      }}>
          BeneWealth Financial operates with the precision and reliability required by professional real estate investors.
        </p>

        {}
        <p className="mt-6 mx-auto text-center font-default text-foreground/70 leading-relaxed" style={{
        maxWidth: "720px",
        fontSize: "16px"
      }}>
          BeneWealth Financial operates as a direct conduit to institutional-grade capital, providing the certainty of execution that sophisticated real estate investors demand. By bypassing the friction of traditional banking, we deliver a streamlined funding infrastructure designed for speed, scale, and professional reliability.
        </p>

        {}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
          {credentials.map((item, i) => <div key={item} data-index={i} className="flex items-center gap-x-3">
              <span className="font-default text-foreground/70" style={{
            fontSize: "12px"
          }}>
                {item}
              </span>
              {i < credentials.length - 1 && <span aria-hidden="true" className="inline-block h-1 w-1 rounded-lg" style={{
            backgroundColor: "var(--secondary)"
          }} />}
            </div>)}
        </div>
      </div>
    </section>;
}